import moment from 'moment'
import React from 'react'
import { ISelectedFiltersUsingName } from '../../../../types'
type IProps ={
    filterForReport :ISelectedFiltersUsingName
}
const ReportDateAndRouts = ( {filterForReport}:IProps) => {
  return (
    <div className='d-flex justify-content-between px-3 pt-2 mb--4'>
                 <p className='font-weight-bold text-dark'> * Report generated on {moment().format("DD/MM/YYYY")} </p>
                 <div className='d-flex text-capitalize'>
                 <p className='font-weight-bold text-dark' >Haryana</p>
                 {filterForReport?.districtId && <p className='font-weight-bold text-dark'>{"/"+ filterForReport?.districtId}</p> }
                 {filterForReport?.blockId && <p className='font-weight-bold text-dark'>{"/"+ filterForReport?.blockId} </p>} 
                 {filterForReport?.schoolId && <p className='font-weight-bold text-dark'>{"/"+ filterForReport?.schoolId} </p>}
                 <p className='font-weight-bold text-dark'> - Statistics</p>
                 </div>
             </div>
  )
}

export default ReportDateAndRouts
